import { createSelector } from '@reduxjs/toolkit';

import { selectMobilePhone, selectWorkPhone } from 'entities/creditForm';
import { selectPledgeEstateData } from 'entities/pledgeEstateForm';

// в форму добавляем номер телефона, чтобы он был доступен при валидации
export const formDataSelector = createSelector(
  [selectPledgeEstateData, selectMobilePhone, selectWorkPhone],
  (pledgeEstateData, mobilePhone, workPhone) => {
    return {
      ...pledgeEstateData,
      mobilePhone,
      workPhone,
    };
  },
);
